// ARCHIVO GENERADO AUTOMÁTICAMENTE. Ejecutar: node scripts/generate-adapters.mjs
// PrimeVue 4.5.5 → @is/uikit-components-vue

import { defineComponent, h, type Component } from 'vue';

// Servicios y buses (re-export con prefijo Is)
export { default as IsConfig } from 'primevue/config';
export { default as IsConfirmationEventBus } from 'primevue/confirmationeventbus';
export { default as IsConfirmationService } from 'primevue/confirmationservice';
export { default as IsDialogService } from 'primevue/dialogservice';
export { default as IsDynamicDialogEventBus } from 'primevue/dynamicdialogeventbus';
export { default as IsOverlayEventBus } from 'primevue/overlayeventbus';
export { default as IsTerminalService } from 'primevue/terminalservice';
export { default as IsToastEventBus } from 'primevue/toasteventbus';
export { default as IsToastService } from 'primevue/toastservice';

// Directivas (re-export con prefijo Is)
export { default as IsAnimateOnScroll } from 'primevue/animateonscroll';
export { default as IsBadgeDirective } from 'primevue/badgedirective';
export { default as IsFocusTrap } from 'primevue/focustrap';
export { default as IsKeyFilter } from 'primevue/keyfilter';
export { default as IsRipple } from 'primevue/ripple';
export { default as IsStyleClass } from 'primevue/styleclass';
export { default as IsTooltip } from 'primevue/tooltip';

// Componentes UI — re-exports directos (Is* que PrimeVue detecta por name interno)
import _PrimeColumn from 'primevue/column';
export const IsColumn = _PrimeColumn;

export type IsColumnProps = InstanceType<typeof _PrimeColumn>['$props'];

import _PrimeColumnGroup from 'primevue/columngroup';
export const IsColumnGroup = _PrimeColumnGroup;

export type IsColumnGroupProps = InstanceType<typeof _PrimeColumnGroup>['$props'];

import _PrimeDataTable from 'primevue/datatable';
export const IsDataTable = _PrimeDataTable;

export type IsDataTableProps = InstanceType<typeof _PrimeDataTable>['$props'];

import _PrimeRow from 'primevue/row';
export const IsRow = _PrimeRow;

export type IsRowProps = InstanceType<typeof _PrimeRow>['$props'];

// Componentes UI — wrapper defineComponent con nombre Is*
import _PrimeAccordion from 'primevue/accordion';
import _PrimeAccordionContent from 'primevue/accordioncontent';
import _PrimeAccordionHeader from 'primevue/accordionheader';
import _PrimeAccordionPanel from 'primevue/accordionpanel';
import _PrimeAccordionTab from 'primevue/accordiontab';
import _PrimeAutoComplete from 'primevue/autocomplete';
import _PrimeAvatar from 'primevue/avatar';
import _PrimeAvatarGroup from 'primevue/avatargroup';
import _PrimeBadge from 'primevue/badge';
import _PrimeBlockUI from 'primevue/blockui';
import _PrimeBreadcrumb from 'primevue/breadcrumb';
import _PrimeButton from 'primevue/button';
import _PrimeButtonGroup from 'primevue/buttongroup';
import _PrimeCalendar from 'primevue/calendar';
import _PrimeCard from 'primevue/card';
import _PrimeCarousel from 'primevue/carousel';
import _PrimeCascadeSelect from 'primevue/cascadeselect';
import _PrimeCheckbox from 'primevue/checkbox';
import _PrimeCheckboxGroup from 'primevue/checkboxgroup';
import _PrimeChip from 'primevue/chip';
import _PrimeChips from 'primevue/chips';
import _PrimeColorPicker from 'primevue/colorpicker';
import _PrimeConfirmDialog from 'primevue/confirmdialog';
import _PrimeConfirmPopup from 'primevue/confirmpopup';
import _PrimeContextMenu from 'primevue/contextmenu';
import _PrimeDataView from 'primevue/dataview';
import _PrimeDatePicker from 'primevue/datepicker';
import _PrimeDeferredContent from 'primevue/deferredcontent';
import _PrimeDialog from 'primevue/dialog';
import _PrimeDivider from 'primevue/divider';
import _PrimeDock from 'primevue/dock';
import _PrimeDrawer from 'primevue/drawer';
import _PrimeDropdown from 'primevue/dropdown';
import _PrimeDynamicDialog from 'primevue/dynamicdialog';
import _PrimeFieldset from 'primevue/fieldset';
import _PrimeFileUpload from 'primevue/fileupload';
import _PrimeFloatLabel from 'primevue/floatlabel';
import _PrimeFluid from 'primevue/fluid';
import _PrimeGalleria from 'primevue/galleria';
import _PrimeIconField from 'primevue/iconfield';
import _PrimeIftaLabel from 'primevue/iftalabel';
import _PrimeImage from 'primevue/image';
import _PrimeImageCompare from 'primevue/imagecompare';
import _PrimeInlineMessage from 'primevue/inlinemessage';
import _PrimeInplace from 'primevue/inplace';
import _PrimeInputChips from 'primevue/inputchips';
import _PrimeInputGroup from 'primevue/inputgroup';
import _PrimeInputGroupAddon from 'primevue/inputgroupaddon';
import _PrimeInputIcon from 'primevue/inputicon';
import _PrimeInputMask from 'primevue/inputmask';
import _PrimeInputNumber from 'primevue/inputnumber';
import _PrimeInputOtp from 'primevue/inputotp';
import _PrimeInputSwitch from 'primevue/inputswitch';
import _PrimeInputText from 'primevue/inputtext';
import _PrimeKnob from 'primevue/knob';
import _PrimeListbox from 'primevue/listbox';
import _PrimeMegaMenu from 'primevue/megamenu';
import _PrimeMenu from 'primevue/menu';
import _PrimeMenubar from 'primevue/menubar';
import _PrimeMessage from 'primevue/message';
import _PrimeMeterGroup from 'primevue/metergroup';
import _PrimeMultiSelect from 'primevue/multiselect';
import _PrimeOrderList from 'primevue/orderlist';
import _PrimeOrganizationChart from 'primevue/organizationchart';
import _PrimeOverlayBadge from 'primevue/overlaybadge';
import _PrimeOverlayPanel from 'primevue/overlaypanel';
import _PrimePaginator from 'primevue/paginator';
import _PrimePanel from 'primevue/panel';
import _PrimePanelMenu from 'primevue/panelmenu';
import _PrimePassword from 'primevue/password';
import _PrimePickList from 'primevue/picklist';
import _PrimePopover from 'primevue/popover';
import _PrimePortal from 'primevue/portal';
import _PrimeProgressBar from 'primevue/progressbar';
import _PrimeProgressSpinner from 'primevue/progressspinner';
import _PrimeRadioButton from 'primevue/radiobutton';
import _PrimeRadioButtonGroup from 'primevue/radiobuttongroup';
import _PrimeRating from 'primevue/rating';
import _PrimeScrollPanel from 'primevue/scrollpanel';
import _PrimeScrollTop from 'primevue/scrolltop';
import _PrimeSelect from 'primevue/select';
import _PrimeSelectButton from 'primevue/selectbutton';
import _PrimeSidebar from 'primevue/sidebar';
import _PrimeSkeleton from 'primevue/skeleton';
import _PrimeSlider from 'primevue/slider';
import _PrimeSpeedDial from 'primevue/speeddial';
import _PrimeSplitButton from 'primevue/splitbutton';
import _PrimeSplitter from 'primevue/splitter';
import _PrimeSplitterPanel from 'primevue/splitterpanel';
import _PrimeStep from 'primevue/step';
import _PrimeStepItem from 'primevue/stepitem';
import _PrimeStepList from 'primevue/steplist';
import _PrimeStepPanel from 'primevue/steppanel';
import _PrimeStepPanels from 'primevue/steppanels';
import _PrimeStepper from 'primevue/stepper';
import _PrimeSteps from 'primevue/steps';
import _PrimeTab from 'primevue/tab';
import _PrimeTabList from 'primevue/tablist';
import _PrimeTabMenu from 'primevue/tabmenu';
import _PrimeTabPanel from 'primevue/tabpanel';
import _PrimeTabPanels from 'primevue/tabpanels';
import _PrimeTabs from 'primevue/tabs';
import _PrimeTabView from 'primevue/tabview';
import _PrimeTag from 'primevue/tag';
import _PrimeTerminal from 'primevue/terminal';
import _PrimeTextarea from 'primevue/textarea';
import _PrimeTieredMenu from 'primevue/tieredmenu';
import _PrimeTimeline from 'primevue/timeline';
import _PrimeToast from 'primevue/toast';
import _PrimeToggleButton from 'primevue/togglebutton';
import _PrimeToggleSwitch from 'primevue/toggleswitch';
import _PrimeToolbar from 'primevue/toolbar';
import _PrimeTree from 'primevue/tree';
import _PrimeTreeSelect from 'primevue/treeselect';
import _PrimeTreeTable from 'primevue/treetable';
import _PrimeVirtualScroller from 'primevue/virtualscroller';

export const IsAccordion = defineComponent({
  name: 'IsAccordion',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAccordion as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAccordionProps = InstanceType<typeof _PrimeAccordion>['$props'];

export const IsAccordionContent = defineComponent({
  name: 'IsAccordionContent',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAccordionContent as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAccordionContentProps = InstanceType<typeof _PrimeAccordionContent>['$props'];

export const IsAccordionHeader = defineComponent({
  name: 'IsAccordionHeader',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAccordionHeader as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAccordionHeaderProps = InstanceType<typeof _PrimeAccordionHeader>['$props'];

export const IsAccordionPanel = defineComponent({
  name: 'IsAccordionPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAccordionPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAccordionPanelProps = InstanceType<typeof _PrimeAccordionPanel>['$props'];

export const IsAccordionTab = defineComponent({
  name: 'IsAccordionTab',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAccordionTab as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAccordionTabProps = InstanceType<typeof _PrimeAccordionTab>['$props'];

export const IsAutoComplete = defineComponent({
  name: 'IsAutoComplete',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAutoComplete as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAutoCompleteProps = InstanceType<typeof _PrimeAutoComplete>['$props'];

export const IsAvatar = defineComponent({
  name: 'IsAvatar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAvatar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAvatarProps = InstanceType<typeof _PrimeAvatar>['$props'];

export const IsAvatarGroup = defineComponent({
  name: 'IsAvatarGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeAvatarGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsAvatarGroupProps = InstanceType<typeof _PrimeAvatarGroup>['$props'];

export const IsBadge = defineComponent({
  name: 'IsBadge',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeBadge as Component, ctx.attrs, ctx.slots);
  },
});

export type IsBadgeProps = InstanceType<typeof _PrimeBadge>['$props'];

export const IsBlockUI = defineComponent({
  name: 'IsBlockUI',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeBlockUI as Component, ctx.attrs, ctx.slots);
  },
});

export type IsBlockUIProps = InstanceType<typeof _PrimeBlockUI>['$props'];

export const IsBreadcrumb = defineComponent({
  name: 'IsBreadcrumb',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeBreadcrumb as Component, ctx.attrs, ctx.slots);
  },
});

export type IsBreadcrumbProps = InstanceType<typeof _PrimeBreadcrumb>['$props'];

export const IsButton = defineComponent({
  name: 'IsButton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeButton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsButtonProps = InstanceType<typeof _PrimeButton>['$props'];

export const IsButtonGroup = defineComponent({
  name: 'IsButtonGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeButtonGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsButtonGroupProps = InstanceType<typeof _PrimeButtonGroup>['$props'];

export const IsCalendar = defineComponent({
  name: 'IsCalendar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCalendar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCalendarProps = InstanceType<typeof _PrimeCalendar>['$props'];

export const IsCard = defineComponent({
  name: 'IsCard',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCard as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCardProps = InstanceType<typeof _PrimeCard>['$props'];

export const IsCarousel = defineComponent({
  name: 'IsCarousel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCarousel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCarouselProps = InstanceType<typeof _PrimeCarousel>['$props'];

export const IsCascadeSelect = defineComponent({
  name: 'IsCascadeSelect',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCascadeSelect as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCascadeSelectProps = InstanceType<typeof _PrimeCascadeSelect>['$props'];

export const IsCheckbox = defineComponent({
  name: 'IsCheckbox',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCheckbox as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCheckboxProps = InstanceType<typeof _PrimeCheckbox>['$props'];

export const IsCheckboxGroup = defineComponent({
  name: 'IsCheckboxGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeCheckboxGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsCheckboxGroupProps = InstanceType<typeof _PrimeCheckboxGroup>['$props'];

export const IsChip = defineComponent({
  name: 'IsChip',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeChip as Component, ctx.attrs, ctx.slots);
  },
});

export type IsChipProps = InstanceType<typeof _PrimeChip>['$props'];

export const IsChips = defineComponent({
  name: 'IsChips',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeChips as Component, ctx.attrs, ctx.slots);
  },
});

export type IsChipsProps = InstanceType<typeof _PrimeChips>['$props'];

export const IsColorPicker = defineComponent({
  name: 'IsColorPicker',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeColorPicker as Component, ctx.attrs, ctx.slots);
  },
});

export type IsColorPickerProps = InstanceType<typeof _PrimeColorPicker>['$props'];

export const IsConfirmDialog = defineComponent({
  name: 'IsConfirmDialog',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeConfirmDialog as Component, ctx.attrs, ctx.slots);
  },
});

export type IsConfirmDialogProps = InstanceType<typeof _PrimeConfirmDialog>['$props'];

export const IsConfirmPopup = defineComponent({
  name: 'IsConfirmPopup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeConfirmPopup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsConfirmPopupProps = InstanceType<typeof _PrimeConfirmPopup>['$props'];

export const IsContextMenu = defineComponent({
  name: 'IsContextMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeContextMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsContextMenuProps = InstanceType<typeof _PrimeContextMenu>['$props'];

export const IsDataView = defineComponent({
  name: 'IsDataView',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDataView as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDataViewProps = InstanceType<typeof _PrimeDataView>['$props'];

export const IsDatePicker = defineComponent({
  name: 'IsDatePicker',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDatePicker as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDatePickerProps = InstanceType<typeof _PrimeDatePicker>['$props'];

export const IsDeferredContent = defineComponent({
  name: 'IsDeferredContent',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDeferredContent as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDeferredContentProps = InstanceType<typeof _PrimeDeferredContent>['$props'];

export const IsDialog = defineComponent({
  name: 'IsDialog',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDialog as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDialogProps = InstanceType<typeof _PrimeDialog>['$props'];

export const IsDivider = defineComponent({
  name: 'IsDivider',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDivider as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDividerProps = InstanceType<typeof _PrimeDivider>['$props'];

export const IsDock = defineComponent({
  name: 'IsDock',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDock as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDockProps = InstanceType<typeof _PrimeDock>['$props'];

export const IsDrawer = defineComponent({
  name: 'IsDrawer',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDrawer as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDrawerProps = InstanceType<typeof _PrimeDrawer>['$props'];

export const IsDropdown = defineComponent({
  name: 'IsDropdown',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDropdown as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDropdownProps = InstanceType<typeof _PrimeDropdown>['$props'];

export const IsDynamicDialog = defineComponent({
  name: 'IsDynamicDialog',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeDynamicDialog as Component, ctx.attrs, ctx.slots);
  },
});

export type IsDynamicDialogProps = InstanceType<typeof _PrimeDynamicDialog>['$props'];

export const IsFieldset = defineComponent({
  name: 'IsFieldset',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeFieldset as Component, ctx.attrs, ctx.slots);
  },
});

export type IsFieldsetProps = InstanceType<typeof _PrimeFieldset>['$props'];

export const IsFileUpload = defineComponent({
  name: 'IsFileUpload',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeFileUpload as Component, ctx.attrs, ctx.slots);
  },
});

export type IsFileUploadProps = InstanceType<typeof _PrimeFileUpload>['$props'];

export const IsFloatLabel = defineComponent({
  name: 'IsFloatLabel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeFloatLabel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsFloatLabelProps = InstanceType<typeof _PrimeFloatLabel>['$props'];

export const IsFluid = defineComponent({
  name: 'IsFluid',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeFluid as Component, ctx.attrs, ctx.slots);
  },
});

export type IsFluidProps = InstanceType<typeof _PrimeFluid>['$props'];

export const IsGalleria = defineComponent({
  name: 'IsGalleria',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeGalleria as Component, ctx.attrs, ctx.slots);
  },
});

export type IsGalleriaProps = InstanceType<typeof _PrimeGalleria>['$props'];

export const IsIconField = defineComponent({
  name: 'IsIconField',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeIconField as Component, ctx.attrs, ctx.slots);
  },
});

export type IsIconFieldProps = InstanceType<typeof _PrimeIconField>['$props'];

export const IsIftaLabel = defineComponent({
  name: 'IsIftaLabel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeIftaLabel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsIftaLabelProps = InstanceType<typeof _PrimeIftaLabel>['$props'];

export const IsImage = defineComponent({
  name: 'IsImage',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeImage as Component, ctx.attrs, ctx.slots);
  },
});

export type IsImageProps = InstanceType<typeof _PrimeImage>['$props'];

export const IsImageCompare = defineComponent({
  name: 'IsImageCompare',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeImageCompare as Component, ctx.attrs, ctx.slots);
  },
});

export type IsImageCompareProps = InstanceType<typeof _PrimeImageCompare>['$props'];

export const IsInlineMessage = defineComponent({
  name: 'IsInlineMessage',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInlineMessage as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInlineMessageProps = InstanceType<typeof _PrimeInlineMessage>['$props'];

export const IsInplace = defineComponent({
  name: 'IsInplace',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInplace as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInplaceProps = InstanceType<typeof _PrimeInplace>['$props'];

export const IsInputChips = defineComponent({
  name: 'IsInputChips',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputChips as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputChipsProps = InstanceType<typeof _PrimeInputChips>['$props'];

export const IsInputGroup = defineComponent({
  name: 'IsInputGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputGroupProps = InstanceType<typeof _PrimeInputGroup>['$props'];

export const IsInputGroupAddon = defineComponent({
  name: 'IsInputGroupAddon',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputGroupAddon as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputGroupAddonProps = InstanceType<typeof _PrimeInputGroupAddon>['$props'];

export const IsInputIcon = defineComponent({
  name: 'IsInputIcon',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputIcon as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputIconProps = InstanceType<typeof _PrimeInputIcon>['$props'];

export const IsInputMask = defineComponent({
  name: 'IsInputMask',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputMask as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputMaskProps = InstanceType<typeof _PrimeInputMask>['$props'];

export const IsInputNumber = defineComponent({
  name: 'IsInputNumber',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputNumber as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputNumberProps = InstanceType<typeof _PrimeInputNumber>['$props'];

export const IsInputOtp = defineComponent({
  name: 'IsInputOtp',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputOtp as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputOtpProps = InstanceType<typeof _PrimeInputOtp>['$props'];

export const IsInputSwitch = defineComponent({
  name: 'IsInputSwitch',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputSwitch as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputSwitchProps = InstanceType<typeof _PrimeInputSwitch>['$props'];

export const IsInputText = defineComponent({
  name: 'IsInputText',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeInputText as Component, ctx.attrs, ctx.slots);
  },
});

export type IsInputTextProps = InstanceType<typeof _PrimeInputText>['$props'];

export const IsKnob = defineComponent({
  name: 'IsKnob',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeKnob as Component, ctx.attrs, ctx.slots);
  },
});

export type IsKnobProps = InstanceType<typeof _PrimeKnob>['$props'];

export const IsListbox = defineComponent({
  name: 'IsListbox',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeListbox as Component, ctx.attrs, ctx.slots);
  },
});

export type IsListboxProps = InstanceType<typeof _PrimeListbox>['$props'];

export const IsMegaMenu = defineComponent({
  name: 'IsMegaMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMegaMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMegaMenuProps = InstanceType<typeof _PrimeMegaMenu>['$props'];

export const IsMenu = defineComponent({
  name: 'IsMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMenuProps = InstanceType<typeof _PrimeMenu>['$props'];

export const IsMenubar = defineComponent({
  name: 'IsMenubar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMenubar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMenubarProps = InstanceType<typeof _PrimeMenubar>['$props'];

export const IsMessage = defineComponent({
  name: 'IsMessage',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMessage as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMessageProps = InstanceType<typeof _PrimeMessage>['$props'];

export const IsMeterGroup = defineComponent({
  name: 'IsMeterGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMeterGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMeterGroupProps = InstanceType<typeof _PrimeMeterGroup>['$props'];

export const IsMultiSelect = defineComponent({
  name: 'IsMultiSelect',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeMultiSelect as Component, ctx.attrs, ctx.slots);
  },
});

export type IsMultiSelectProps = InstanceType<typeof _PrimeMultiSelect>['$props'];

export const IsOrderList = defineComponent({
  name: 'IsOrderList',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeOrderList as Component, ctx.attrs, ctx.slots);
  },
});

export type IsOrderListProps = InstanceType<typeof _PrimeOrderList>['$props'];

export const IsOrganizationChart = defineComponent({
  name: 'IsOrganizationChart',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeOrganizationChart as Component, ctx.attrs, ctx.slots);
  },
});

export type IsOrganizationChartProps = InstanceType<typeof _PrimeOrganizationChart>['$props'];

export const IsOverlayBadge = defineComponent({
  name: 'IsOverlayBadge',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeOverlayBadge as Component, ctx.attrs, ctx.slots);
  },
});

export type IsOverlayBadgeProps = InstanceType<typeof _PrimeOverlayBadge>['$props'];

export const IsOverlayPanel = defineComponent({
  name: 'IsOverlayPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeOverlayPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsOverlayPanelProps = InstanceType<typeof _PrimeOverlayPanel>['$props'];

export const IsPaginator = defineComponent({
  name: 'IsPaginator',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePaginator as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPaginatorProps = InstanceType<typeof _PrimePaginator>['$props'];

export const IsPanel = defineComponent({
  name: 'IsPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPanelProps = InstanceType<typeof _PrimePanel>['$props'];

export const IsPanelMenu = defineComponent({
  name: 'IsPanelMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePanelMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPanelMenuProps = InstanceType<typeof _PrimePanelMenu>['$props'];

export const IsPassword = defineComponent({
  name: 'IsPassword',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePassword as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPasswordProps = InstanceType<typeof _PrimePassword>['$props'];

export const IsPickList = defineComponent({
  name: 'IsPickList',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePickList as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPickListProps = InstanceType<typeof _PrimePickList>['$props'];

export const IsPopover = defineComponent({
  name: 'IsPopover',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePopover as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPopoverProps = InstanceType<typeof _PrimePopover>['$props'];

export const IsPortal = defineComponent({
  name: 'IsPortal',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimePortal as Component, ctx.attrs, ctx.slots);
  },
});

export type IsPortalProps = InstanceType<typeof _PrimePortal>['$props'];

export const IsProgressBar = defineComponent({
  name: 'IsProgressBar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeProgressBar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsProgressBarProps = InstanceType<typeof _PrimeProgressBar>['$props'];

export const IsProgressSpinner = defineComponent({
  name: 'IsProgressSpinner',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeProgressSpinner as Component, ctx.attrs, ctx.slots);
  },
});

export type IsProgressSpinnerProps = InstanceType<typeof _PrimeProgressSpinner>['$props'];

export const IsRadioButton = defineComponent({
  name: 'IsRadioButton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeRadioButton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsRadioButtonProps = InstanceType<typeof _PrimeRadioButton>['$props'];

export const IsRadioButtonGroup = defineComponent({
  name: 'IsRadioButtonGroup',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeRadioButtonGroup as Component, ctx.attrs, ctx.slots);
  },
});

export type IsRadioButtonGroupProps = InstanceType<typeof _PrimeRadioButtonGroup>['$props'];

export const IsRating = defineComponent({
  name: 'IsRating',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeRating as Component, ctx.attrs, ctx.slots);
  },
});

export type IsRatingProps = InstanceType<typeof _PrimeRating>['$props'];

export const IsScrollPanel = defineComponent({
  name: 'IsScrollPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeScrollPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsScrollPanelProps = InstanceType<typeof _PrimeScrollPanel>['$props'];

export const IsScrollTop = defineComponent({
  name: 'IsScrollTop',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeScrollTop as Component, ctx.attrs, ctx.slots);
  },
});

export type IsScrollTopProps = InstanceType<typeof _PrimeScrollTop>['$props'];

export const IsSelect = defineComponent({
  name: 'IsSelect',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSelect as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSelectProps = InstanceType<typeof _PrimeSelect>['$props'];

export const IsSelectButton = defineComponent({
  name: 'IsSelectButton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSelectButton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSelectButtonProps = InstanceType<typeof _PrimeSelectButton>['$props'];

export const IsSidebar = defineComponent({
  name: 'IsSidebar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSidebar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSidebarProps = InstanceType<typeof _PrimeSidebar>['$props'];

export const IsSkeleton = defineComponent({
  name: 'IsSkeleton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSkeleton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSkeletonProps = InstanceType<typeof _PrimeSkeleton>['$props'];

export const IsSlider = defineComponent({
  name: 'IsSlider',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSlider as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSliderProps = InstanceType<typeof _PrimeSlider>['$props'];

export const IsSpeedDial = defineComponent({
  name: 'IsSpeedDial',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSpeedDial as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSpeedDialProps = InstanceType<typeof _PrimeSpeedDial>['$props'];

export const IsSplitButton = defineComponent({
  name: 'IsSplitButton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSplitButton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSplitButtonProps = InstanceType<typeof _PrimeSplitButton>['$props'];

export const IsSplitter = defineComponent({
  name: 'IsSplitter',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSplitter as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSplitterProps = InstanceType<typeof _PrimeSplitter>['$props'];

export const IsSplitterPanel = defineComponent({
  name: 'IsSplitterPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSplitterPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsSplitterPanelProps = InstanceType<typeof _PrimeSplitterPanel>['$props'];

export const IsStep = defineComponent({
  name: 'IsStep',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStep as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepProps = InstanceType<typeof _PrimeStep>['$props'];

export const IsStepItem = defineComponent({
  name: 'IsStepItem',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStepItem as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepItemProps = InstanceType<typeof _PrimeStepItem>['$props'];

export const IsStepList = defineComponent({
  name: 'IsStepList',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStepList as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepListProps = InstanceType<typeof _PrimeStepList>['$props'];

export const IsStepPanel = defineComponent({
  name: 'IsStepPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStepPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepPanelProps = InstanceType<typeof _PrimeStepPanel>['$props'];

export const IsStepPanels = defineComponent({
  name: 'IsStepPanels',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStepPanels as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepPanelsProps = InstanceType<typeof _PrimeStepPanels>['$props'];

export const IsStepper = defineComponent({
  name: 'IsStepper',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeStepper as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepperProps = InstanceType<typeof _PrimeStepper>['$props'];

export const IsSteps = defineComponent({
  name: 'IsSteps',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeSteps as Component, ctx.attrs, ctx.slots);
  },
});

export type IsStepsProps = InstanceType<typeof _PrimeSteps>['$props'];

export const IsTab = defineComponent({
  name: 'IsTab',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTab as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabProps = InstanceType<typeof _PrimeTab>['$props'];

export const IsTabList = defineComponent({
  name: 'IsTabList',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabList as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabListProps = InstanceType<typeof _PrimeTabList>['$props'];

export const IsTabMenu = defineComponent({
  name: 'IsTabMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabMenuProps = InstanceType<typeof _PrimeTabMenu>['$props'];

export const IsTabPanel = defineComponent({
  name: 'IsTabPanel',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabPanel as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabPanelProps = InstanceType<typeof _PrimeTabPanel>['$props'];

export const IsTabPanels = defineComponent({
  name: 'IsTabPanels',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabPanels as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabPanelsProps = InstanceType<typeof _PrimeTabPanels>['$props'];

export const IsTabs = defineComponent({
  name: 'IsTabs',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabs as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabsProps = InstanceType<typeof _PrimeTabs>['$props'];

export const IsTabView = defineComponent({
  name: 'IsTabView',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTabView as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTabViewProps = InstanceType<typeof _PrimeTabView>['$props'];

export const IsTag = defineComponent({
  name: 'IsTag',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTag as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTagProps = InstanceType<typeof _PrimeTag>['$props'];

export const IsTerminal = defineComponent({
  name: 'IsTerminal',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTerminal as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTerminalProps = InstanceType<typeof _PrimeTerminal>['$props'];

export const IsTextarea = defineComponent({
  name: 'IsTextarea',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTextarea as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTextareaProps = InstanceType<typeof _PrimeTextarea>['$props'];

export const IsTieredMenu = defineComponent({
  name: 'IsTieredMenu',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTieredMenu as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTieredMenuProps = InstanceType<typeof _PrimeTieredMenu>['$props'];

export const IsTimeline = defineComponent({
  name: 'IsTimeline',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTimeline as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTimelineProps = InstanceType<typeof _PrimeTimeline>['$props'];

export const IsToast = defineComponent({
  name: 'IsToast',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeToast as Component, ctx.attrs, ctx.slots);
  },
});

export type IsToastProps = InstanceType<typeof _PrimeToast>['$props'];

export const IsToggleButton = defineComponent({
  name: 'IsToggleButton',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeToggleButton as Component, ctx.attrs, ctx.slots);
  },
});

export type IsToggleButtonProps = InstanceType<typeof _PrimeToggleButton>['$props'];

export const IsToggleSwitch = defineComponent({
  name: 'IsToggleSwitch',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeToggleSwitch as Component, ctx.attrs, ctx.slots);
  },
});

export type IsToggleSwitchProps = InstanceType<typeof _PrimeToggleSwitch>['$props'];

export const IsToolbar = defineComponent({
  name: 'IsToolbar',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeToolbar as Component, ctx.attrs, ctx.slots);
  },
});

export type IsToolbarProps = InstanceType<typeof _PrimeToolbar>['$props'];

export const IsTree = defineComponent({
  name: 'IsTree',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTree as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTreeProps = InstanceType<typeof _PrimeTree>['$props'];

export const IsTreeSelect = defineComponent({
  name: 'IsTreeSelect',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTreeSelect as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTreeSelectProps = InstanceType<typeof _PrimeTreeSelect>['$props'];

export const IsTreeTable = defineComponent({
  name: 'IsTreeTable',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeTreeTable as Component, ctx.attrs, ctx.slots);
  },
});

export type IsTreeTableProps = InstanceType<typeof _PrimeTreeTable>['$props'];

export const IsVirtualScroller = defineComponent({
  name: 'IsVirtualScroller',
  inheritAttrs: true,
  setup(_props, ctx) {
    return () => h(_PrimeVirtualScroller as Component, ctx.attrs, ctx.slots);
  },
});

export type IsVirtualScrollerProps = InstanceType<typeof _PrimeVirtualScroller>['$props'];
